import { Component, Input, ViewChild } from '@angular/core';
import { ModalComponent, CheckIconComponent } from 'remarketing-ui-components-lib';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
    selector: 'app-action-submitted-content-modal',
    templateUrl: './action-submitted-content-modal.component.html',
    styleUrls: ['./action-submitted-content-modal.component.scss'],
    imports: [TranslocoDirective, ModalComponent, CheckIconComponent]
})
export class ActionSubmittedContentModalComponent {
  @ViewChild(ModalComponent) modal: ModalComponent;

  @Input() heading: string;
  @Input() content: string;

  show() {
    this.modal.show();
  }

  close() {
    this.modal.close();
  }

}
